import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MARKETPLACE_ERROR_HANDLERS } from '@platform-frontend/marketplace';
import { DirectDebitService } from '@platform-frontend/payment-util';
import { PLATFORM_ENVIRONMENT } from '@platform-frontend/platform';
import { convertToHttpParams, handleErrors, ShowErrorNotification } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { MSG_IBAN_DETAILS_DEFAULT, MSG_IBAN_DETAILS_IBAN_SERVICE_NOT_REACHABLE } from '../notification-messages';
import { IbanDetails } from './model/iban-details';

@Injectable({
  providedIn: 'root'
})
export class IbanDetailsService {
  constructor(private http: HttpClient, private directDebitService: DirectDebitService) {}

  getIbanDetails(iban: string): Observable<IbanDetails> {
    const params = convertToHttpParams({
      iban: this.directDebitService.simplifyIban(iban)
    });

    return this.http.get<IbanDetails>(PLATFORM_ENVIRONMENT.apiUrl + '/ibanDetails', { params }).pipe(
      handleErrors(MARKETPLACE_ERROR_HANDLERS, {
        IBAN_INVALID: () => undefined,
        IBAN_SERVICE_NOT_REACHABLE: new ShowErrorNotification(MSG_IBAN_DETAILS_IBAN_SERVICE_NOT_REACHABLE),
        DEFAULT: new ShowErrorNotification(MSG_IBAN_DETAILS_DEFAULT)
      })
    );
  }
}
